import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  tenants: () => client.get("/tenants").then((r) => r.data),
  login: (body) => client.post("/auth/login", body).then((r) => r.data),
  sectorPacks: () => client.get("/sector-packs").then((r) => r.data),
  providers: () => client.get("/providers").then((r) => r.data),

  departments: (tid) => client.get(`/tenants/${tid}/departments`).then((r) => r.data),
  addDepartment: (tid, body) => client.post(`/tenants/${tid}/departments`, body).then((r) => r.data),
  delDepartment: (did) => client.delete(`/departments/${did}`).then((r) => r.data),

  users: (tid) => client.get(`/tenants/${tid}/users`).then((r) => r.data),
  addUser: (tid, body) => client.post(`/tenants/${tid}/users`, body).then((r) => r.data),
  delUser: (uid) => client.delete(`/users/${uid}`).then((r) => r.data),
  signoff: (uid, body) => client.post(`/users/${uid}/signoff`, body).then((r) => r.data),

  policy: (tid, deptId) =>
    client.get(`/tenants/${tid}/policy`, { params: { department_id: deptId } }).then((r) => r.data),
  updatePolicy: (tid, body) => client.put(`/tenants/${tid}/policy`, body).then((r) => r.data),
  setPolicyPreset: (tid, body) => client.post(`/tenants/${tid}/policy/preset`, body).then((r) => r.data),
  setPresetConfig: (tid, categories, user_id) => client.put(`/tenants/${tid}/policy/preset-config`, { categories, user_id }).then((r) => r.data),
  policyEvents: (tid) => client.get(`/tenants/${tid}/policy-events`).then((r) => r.data),
  updateAllowlist: (tid, body) => client.put(`/tenants/${tid}/allowlist`, body).then((r) => r.data),

  customCategories: (tid) => client.get(`/tenants/${tid}/custom-categories`).then((r) => r.data),
  addCustomCategory: (tid, body) => client.post(`/tenants/${tid}/custom-categories`, body).then((r) => r.data),
  delCustomCategory: (cid) => client.delete(`/custom-categories/${cid}`).then((r) => r.data),
  testPattern: (body) => client.post(`/custom-categories/test`, body).then((r) => r.data),

  chat: (body) => client.post("/gateway/chat", body).then((r) => r.data),
  uploadFile: (formData) =>
    client.post("/files/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  verifyAudit: (auditId, body) => client.post(`/audit/${auditId}/verify`, body).then((r) => r.data),
  deleteAudit: (auditId, body) => client.delete(`/audit/${auditId}`, { data: body }).then((r) => r.data),
  audit: (tid, params) => client.get(`/tenants/${tid}/audit`, { params }).then((r) => r.data),
  dashboard: (tid) => client.get(`/tenants/${tid}/dashboard`).then((r) => r.data),
  report: (tid, month) =>
    client.get(`/tenants/${tid}/report`, { params: { month } }).then((r) => r.data),
  verifyReport: (tid, month) =>
    client.get(`/tenants/${tid}/report/verify`, { params: month ? { month } : {} }).then((r) => r.data),
  conversations: (tid, params = {}) =>
    client.get(`/tenants/${tid}/conversations`, { params }).then((r) => r.data),
  deleteConversation: (tid, cid, body) =>
    client.delete(`/tenants/${tid}/conversations/${cid}`, { data: body }).then((r) => r.data),

  onboardPreview: (body) => client.post("/onboarding/preview", body).then((r) => r.data),
  onboard: (body) => client.post("/onboarding", body).then((r) => r.data),
  activate: (tid) => client.post(`/tenants/${tid}/activate`).then((r) => r.data),

  integration: (tid) => client.get(`/integration/${tid}`).then((r) => r.data),

  platformLogin: (body) => client.post("/platform/login", body).then((r) => r.data),
  platformOverview: () => client.get("/platform/overview").then((r) => r.data),
  gateVerify: (body) => client.post("/gate/verify", body).then((r) => r.data),
};
